import { NodeType } from '@cadet-dsl';
import { type SnorfSpec } from '@snorf';
import { IString } from '@strings';
import { assertInstanceOf } from '@utils';
import { ElementSpec } from './ElementSpec';
import type { NodeLayout } from './NodeLayout';

// Runtime data associated with a Node in the Doc graph
export class NodeSpec extends ElementSpec {
  type: NodeType; // UNIT or GROUP
  // Transient runtime-only fields used during title-change interpolation.
  // These are NEVER serialized; they are injected by Doc.interp().
  endLayout?: NodeLayout;
  endOpacity?: number;
  snorfSpec?: SnorfSpec;

  constructor(cls: string, type: NodeType, attrs: Record<string, unknown>) {
    super(cls, attrs);
    this.type = type;
  }

  // Convenience accessors that convert IString to string for display
  get title(): IString {
    const value = this.attrs.title ?? IString.EMPTY;
    assertInstanceOf(value, IString);
    return value;
  }

  set title(value: IString) {
    assertInstanceOf(value, IString);
    this.attrs.title = value;
  }
}
